import { NextSeo } from 'next-seo';

import placeholder from 'lib/placeholder';

const ForumHead = () => (
  <NextSeo
    description={placeholder('seo.forum.description')}
    openGraph={{
      description: placeholder('seo.forum.description'),
    }}
    title={placeholder('seo.forum.title')}
  />
);

export default ForumHead;
